export function setPopupMenu(status){
    return dispatch=>{
       return dispatch({
            type:"SET_POPUP_MENU",
            data:status
        });
    }
}
export function setMapPop(status) {
    return dispatch => {
      dispatch({
        type: "MAP_POP",
        data: status
      });
    }
  }